import { Especialidade } from "../especialidade/especialidade";
import { MedicoPlanoSaude } from "./medico-plano-saude";

export class Medico {

    id: number = 0;

    nome: string = '';

    cpf: string = '';

    logradouro: string = '';

    complemento: string = '';

    numero: string = '';

    bairro: string = '';

    cidade: string = '';

    estado: string = '';

    cep: string = '';

    fone: string = '';
    
    especialidade: Especialidade = new Especialidade();
    
    medicoPlanoSaude: Array<MedicoPlanoSaude> = [];

    qtdDiasAgenda: number = 0;

    idEspecialidade: number = 0;

    constructor() {
    }
}
